import React from "react";
import "../assets/ConfirmationDialog.css";

function ConfirmationDialog({ message, onConfirm, onCancel }) {
    return (
      <div className="confirmation-dialog">
        <div className="confirmation-dialog-content">
          <p>{message}</p>
          <div className="confirmation-dialog-buttons">
            <button onClick={onConfirm}>Confirm</button>
            <button onClick={onCancel}>Cancel</button>
          </div>
        </div>
      </div>
    );
  }
  
  export default ConfirmationDialog;  